const appRoutes = {
  login: "/login",
  diet: "/diet",
  users: "/users",
  trainers: "/trainers",
  dashboard: "/dashboard",
};

const userRoutes = {
  userDetails: "/users/:id",
};

const trainerRoutes = {
  personalDetails: appRoutes.trainers + "/:id",
  exercises: appRoutes.trainers + "/:id/exercises",
  trainingPrograms: appRoutes.trainers + "/:id/training-programs",
  workouts: appRoutes.trainers + "/:id/workouts",
  techniqueVideos: appRoutes.trainers + "/:id/technique-videos",
  dashboard: appRoutes.trainers + "/:id/dashboard",
};

const dietRoutes = {};

export const routes = {
  appRoutes,
  userRoutes,
  trainerRoutes,
  dietRoutes,
};
